const instance = "DEV";  

let KEY_ID;
if(instance == "LOCAL") {
  KEY_ID = "rzp_test_i1tbOaCE3MyNGd"; 
} else if(instance == "DEV") { 
  KEY_ID = "rzp_test_i1tbOaCE3MyNGd";     
} else if(instance == "UAT") {  
  KEY_ID = "rzp_live_OW24ylLAhLAeCl";    
} else if(instance == "PROD") {
//   KEY_ID = "rzp_live_OW24ylLAhLAeCl";    
}

export default KEY_ID;